import { AmbassadorFourth, socialMediaSingle } from '../../../enums';
import LazyLoad from 'react-lazyload';
import React from 'react';
import Marquee from 'react-fast-marquee';
import { AmbassadorDoctorSliderProps } from './ambassador-doctor-slider.props';

export const AmbassadorDoctorSliderOrganism = (
  props: AmbassadorDoctorSliderProps
) => {
  return (
    <div className="w-full  py-10 bg-white">
      <div className="w-full lg:w-10/12 flex flex-col items-end mb-8">
        <div className="w-32 flex flex-row self-end items-end">
          <a href={socialMediaSingle.IG} target="_blank" rel="noreferrer">
            <LazyLoad offset={100} height={100}>
              <img
                src="/images/icons/doctor-ambassador/social/ig.svg"
                width={24}
                height={24}
                className="mr-5 "
              />
            </LazyLoad>
          </a>
          <a href={socialMediaSingle.FB} target="_blank" rel="noreferrer">
            <LazyLoad offset={100} height={100}>
              <img
                src="/images/icons/doctor-ambassador/social/fb.svg"
                className="mr-5"
                width={14}
                height={24}
              />
            </LazyLoad>
          </a>
          <a href={socialMediaSingle.TWIT} target="_blank" rel="noreferrer">
            <LazyLoad offset={100} height={100}>
              <img
                src="/images/icons/doctor-ambassador/social/twitter.svg"
                className=""
                width={28}
                height={22}
              />
            </LazyLoad>
          </a>
        </div>
      </div>
      <div className="w-full px-5">
        <Marquee gradient={false} speed={50} pauseOnHover={false}>
          <div className="ml-0 mr-3 lg:mr-9">
            <div className="focus:outline-none box-border ml-8 lg:ml-16">
              <LazyLoad offset={250} height={250}>
                <img
                  src={`/images/ambassadors/marquee/${props.image1}`}
                  className="outline-none h-46 lg:h-60 w-auto"
                />
              </LazyLoad>
            </div>
            <div className="focus:outline-none box-border block mt-6 lg:mt-9">
              <LazyLoad offset={250} height={250}>
                <img
                  src={`/images/ambassadors/marquee/${props.image2}`}
                  className="outline-none h-40 lg:h-52 w-auto"
                />
              </LazyLoad>
            </div>
          </div>
          <div className="block  mx-3 lg:mx-9">
            <div className="focus:outline-none box-border block">
              <LazyLoad offset={250} height={500}>
                <img
                  src={`/images/ambassadors/marquee/${props.mainImage}`}
                  className="outline-none h-85 lg:h-110 w-auto"
                />
              </LazyLoad>
            </div>
          </div>
          <div className="block  ml-3 lg:ml-9 mr-0">
            <div className="focus:outline-none box-border ">
              <LazyLoad offset={250} height={250}>
                <img
                  src={`/images/ambassadors/marquee/${props.image3}`}
                  className="outline-none h-46 lg:h-60 w-auto"
                />
              </LazyLoad>
            </div>
            <div className="focus:outline-none box-border block mt-6 lg:mt-9 mr-0">
              <LazyLoad offset={250} height={250}>
                <img
                  src={`/images/ambassadors/marquee/${props.image4}`}
                  className="outline-none h-40 lg:h-52 w-auto"
                />
              </LazyLoad>
            </div>
          </div>
        </Marquee>
      </div>

      <div className="w-4/5 lg:w-10/12  mx-auto mt-8">
        <p className="block mb-5 font-waldo-sans text-lg leading-6 font-normal text-left lg:text-center">
          {AmbassadorFourth.FOURTH_DESC}
        </p>
      </div>
    </div>
  );
};
